import { styled } from "styled-components";

export const DateBage = styled.div`
    border-radius: 50px;
    background: #949090;
    color: #fff;
    font-weight: 600;
    padding: 4px 24px;
    margin-top: 21px;
    margin-bottom: 15px;
    width: fit-content;
`

export const DateContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const InputMessage = styled.div`
    position: relative;
    background: #E2F9D0;
    color: #000;
    padding: 8px 16px;
    border-radius: 20px;
    max-width: 80%;
    margin-bottom: 11px;
    margin-left: 64px;
    line-height: 25px;

    &:after {
        content: "";
        position: absolute;
        bottom: 2px;
        right: -10px;
        width: 20px;
        height: 13px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='13' viewBox='0 0 20 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.528 9.13484C9.87123 7.14178 8.65357 2.21451 8.37682 0C1.73501 1.66088 -3.24635 3.32176 2.56524 9.13484C7.21451 13.7853 16.1256 13.287 20 12.4566C18.6163 12.1798 15.1847 11.1279 12.528 9.13484Z' fill='%23E2F9D0'/%3E%3C/svg%3E");
        background-size: cover;
        background-repeat: no-repeat;
    }
`

export const OutputMessage = styled.div`
    position: relative;
    line-height: 25px;
    align-self: flex-start;
    background: #f2f2f2;
    padding: 8px 16px;
    border-radius: 20px;
    max-width: 80%;
    margin-bottom: 11px;
    margin-right: 64px;

    &:after {
        content: "";
        position: absolute;
        bottom: 2px;
        left: -10px;
        width: 18px;
        height: 13px;
        background-image: url("data:image/svg+xml,%3Csvg width='18' height='13' viewBox='0 0 18 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.39446 9.13484C8.66804 7.14178 9.7101 2.21451 9.94693 0C15.6309 1.66088 19.8939 3.32176 14.9204 9.13484C10.9416 13.7853 3.31564 13.287 0 12.4566C1.18416 12.1798 4.12087 11.1279 6.39446 9.13484Z' fill='%23F2F2F2'/%3E%3C/svg%3E");
        background-size: cover;
        background-repeat: no-repeat;
    }
`

export const MessagesContainer = styled.div`
`

export const MessageTime = styled.div`
    position: absolute;
    bottom: 6px;
    right: 9px;
    color: #989898;
    z-index: 999;
`

export const SummaryContainer = styled.div`
    border: 1px solid #EDEDED;
`

export const SystemMessage = styled.div`
    padding: 14px 25px;
    border: 1px solid #D5D5D5;
    border-radius: 20px;
    margin: 15px 44px 15px 0;
    line-height: 25px;
`
